class commonHelper{
	constructor() {
		
	}
	slideout() {
        $('#navbarCollapse').on('shown.bs.collapse', function() {
            $('#slideoutBackdrop').addClass('show');
            $('body').addClass('noscroll');
            setTimeout(function() {$('#slideoutlist').focus()}, 300);
        });
        $('#navbarCollapse').on('hide.bs.collapse', function() {
            $('#slideoutBackdrop').removeClass('show');
            $('body').removeClass('noscroll');
            $('#brand').focus();
        });
    }
    loadiframe(el) {
        $(el).on('show.bs.modal', function() {
            var $iframe = $(el).find('.iframe');
            $iframe.attr('src', $iframe.data('src'));
        });
        $(el).on('hidden.bs.modal', function() {
            var $iframe = $(el).find('.iframe');
            $iframe.attr('src', '');
        });
    }
    expandContent() {
        if (window.innerWidth > 992) {

             var cards = document.querySelectorAll('.card-link');
             for (var i = 0; i < cards.length; i++) {
                 let item = cards[i];
                 item.addEventListener('mouseover', function() {showButton(item)});
                 item.addEventListener('focus', function() {showButton(item)});
                 item.addEventListener('mouseout', function() {hideButton(item)});
                 item.addEventListener('focusout', function() {hideButton(item)});
             }
        }
        var showButton = function(item) {
            var button = item.querySelector('.collapse');
            var link = item.querySelector('.btn-arrow');
            $(link).addClass('fade');
            $(button).collapse('show');
        }
        var hideButton = function(item) {
            var button = item.querySelector('.collapse');
            $(button).collapse('hide');
        }
    }
    loadmore() {
        document.getElementById('loadmore').onclick = function() {
            var button = document.getElementById('loadmore');
            button.dataset.page = parseInt(button.dataset.page) + 1;

            var url = window.location.href;
            var newURL;

            var position = url.indexOf('?');
            if (position > -1) {
                var pageNumString = url.substring(position+6, url.length);
                var pageNum = parseInt(pageNumString);            
                pageNum++;
                newURL = url.replace(pageNumString, pageNum);
            } else {
                newURL = url + '?page=2';
            }

            history.pushState({state:1, rand: Math.random()}, '', newURL);

            data = { 
                "action": "load_more_posts",
                "page": button.dataset.page,
                "postperpage": 12,
                "term": button.dataset.term
            };

            $.post( "/wp-admin/admin-ajax.php", data, function( response ) {

                var button = document.getElementById('loadmore');

                if(response == 0) {
                    button.classList.add('d-none');
                }
                else {
                    $('.blog-posts').append(response);
                    app.common.expandContent();
                }

            });
        };
    }
    modalFocus(el) {
        // Get the modal id and select the modal itself
        var targetObject = document.querySelectorAll(el.dataset.target);

        // Get the current active element so we can refocus on it when we exit the modal
        focusedElBeforeOpen = document.activeElement;    

        // Get the modal dialog
        var dialog = targetObject[0];

        // Select all of the focusable elements within the modal (buttons, a, etc.)
        var focusableEls = dialog.querySelectorAll('button, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]');
        focusableEls = Array.prototype.slice.call(focusableEls);

        // Grab the first focusable element and the last one
        var firstFocusableEl = focusableEls[0],
        lastFocusableEl = focusableEls[focusableEls.length - 1];

        // Once the modal is shown, focus on the first element
        $(dialog).on('show.bs.modal', function (e) {
            window.setTimeout(function() {
                firstFocusableEl.focus();
            }, 300);
        });

        // On modal close, refocus on the element that had focus before
        dialog.addEventListener('hide.bs.modal', function (e) {
            this.focusedElBeforeOpen.focus();
        });
    
    }
    createCookie(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }
    cookieConsent() {
        var cta = $('.cookie-consent');
        if(!app.common.readCookie('hide_message')){
            console.log('show');
          cta.show();
        }
		$('#consentOk').on('click', () => {
            cta.hide();
            app.common.createCookie('hide_message', true, 45);
        });
    }
}
window.app.add('common', new commonHelper());